import React from 'react';
import {Skeleton, Stack} from "@mui/material"

function TablePageSkeleton() {
    return (
        <Stack spacing={2}>
            <Skeleton variant="text" width={200} height={40}/>
            <Stack direction="row" spacing={1} justifyContent="space-between">
                <Skeleton variant="rounded" width={280} height={36}/>
                <Stack direction="row" spacing={1}>
                    <Skeleton variant="rounded" width={110} height={36}/>
                    <Skeleton variant="rounded" width={110} height={36}/>
                </Stack>
            </Stack>
            <Skeleton variant="rounded" height={520}/>
        </Stack>
    );
}

export default TablePageSkeleton;
